import { Box } from '@mui/material';
import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

export const StyledWrapper = styled(Box)(() => ({
  backgroundColor: COLORS.white2,
}));

export const StyledContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '128px',
    paddingBottom: '100px',
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      paddingTop: '50px',
      paddingBottom: '50px',
    },
  };
});

export const StyledTitle = styled('div')(() => ({
  display: 'flex',
  paddingBottom: '80px',
}));

export const StyledCardsWrapper = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '61px',
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      flexDirection: 'column',
    },
  };
});

export const StyledCard = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  maxWidth: '362px',
  width: '100%',
  padding: '40px 30px 32px 30px',
  gap: '17px',
  position: 'relative',

  '.gradient-section': {
    position: 'absolute',
    left: 0,
    top: '-13px',
    zIndex: 0,
    width: '360px',
    height: '360px',
  },

  '.blue-gradient': {
    background: 'radial-gradient(41.39% 41.39% at 50% 50%, rgba(33, 150, 243, 0.1) 0%, rgba(19, 87, 141, 0) 100%)',
  },

  '.green-gradient': {
    background: 'radial-gradient(44.03% 44.03% at 50% 50%, rgba(41, 192, 86, 0.1) 0%, rgba(41, 191, 86, 0) 100%)',
  },

  '.orange-gradient': {
    background: 'radial-gradient(41.67% 41.67% at 50% 50%, rgba(255, 143, 68, 0.1) 0%, rgba(245, 167, 115, 0) 100%)',
  },
}));

export const StyledTextWrapper = styled('div')(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '6px',
  textAlign: 'center',

  h4: {
    textAlign: 'center',
  },
}));

export const StyledImage = styled('img')(() => ({
  position: 'relative',
  height: '138px',
  width: '260px',
}));

export const StyledNumber = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: COLORS.textMain,
  width: '41px',
  height: '41px',
  borderRadius: '100px',
  color: COLORS.white,
  fontSize: '20px',
  fontWeight: 700,
  position: 'absolute',
  top: -21,
  left: 155,
}));

export const StyledArrow = styled('img')(({ theme }) => ({
  height: '12px',
  width: '34px',
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  right: '-47px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    position: 'relative',
    right: 'unset',
    rotate: '90deg',
  },
}));
